import { render, staticRenderFns } from "./AppBarParticipant.vue?vue&type=template&id=f91cb052"
import script from "./AppBarParticipant.vue?vue&type=script&lang=js"
export * from "./AppBarParticipant.vue?vue&type=script&lang=js"
import style0 from "./AppBarParticipant.vue?vue&type=style&index=0&id=f91cb052&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports